import type { CSSProperties } from 'react';
import { Badge } from '../Badge';
import { BackButton } from '../BackButton';
import {
  BadgeContainer,
  ImageContainer,
  Outer,
  OuterSticky,
  Overlay,
  OverlayContentSlot,
} from './ImageFrame.styles';
import type { ImageFrameProps } from './ImageFrame.types';

function ImageFrameBase({
  children,
  onBack,
  backLabel,
  overlayContent,
  badge,
  mobileHeight,
  mobileAspectRatio,
  mobileMaxHeight,
  desktopHeight,
  sticky = true,
}: ImageFrameProps) {
  const WrapperEl = sticky ? OuterSticky : Outer;

  const cssVars = {
    ...(mobileHeight ? { '--image-frame-mobile-height': mobileHeight } : {}),
    ...(mobileAspectRatio ? { '--image-frame-mobile-aspect-ratio': mobileAspectRatio } : {}),
    ...(mobileMaxHeight ? { '--image-frame-mobile-max-height': mobileMaxHeight } : {}),
    ...(desktopHeight ? { '--image-frame-desktop-height': desktopHeight } : {}),
  } as CSSProperties;

  const showOverlay = overlayContent || onBack;

  return (
    <WrapperEl>
      <ImageContainer style={cssVars}>
        {children}
        {showOverlay && (
          <Overlay>
            {onBack && <BackButton onClick={onBack} variant="overlay" label={backLabel} />}
            {overlayContent != null && <OverlayContentSlot>{overlayContent}</OverlayContentSlot>}
          </Overlay>
        )}
        {badge && <BadgeContainer>{badge}</BadgeContainer>}
      </ImageContainer>
    </WrapperEl>
  );
}

export const ImageFrame = Object.assign(ImageFrameBase, {
  Badge,
});
